import { createContext } from 'react';

// Context for Authentication and core app state
export const AuthContext = createContext(null);

// Context for Game-specific details
export const GameContext = createContext(null);
